import Lingvo from './Lingvo.js';
import {BAZA_URL} from './Kunteksto.js';

class Lingvoj
{
    constructor ()
    {
        this.fasadLingvoj = [];
        this.vortarLingvoj = [];
        this.ĉiuj = [];
        this.ŝarĝita = false;
        this.lingvoj = new Map();
    }
    
    ŝarĝuLingvojn(informilo)
    {
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "lingvoj.php";
        request.open('GET', url);
        request.onload = function ()
        {
            const data = JSON.parse (request.responseText);
            mi.prilaboruRespondon (data, informilo);
        };
        request.send();        
    }
    
    prilaboruRespondon (data, informilo)
    {        
        this.fasadLingvoj = [];
        this.vortarLingvoj = [];
        this.ĉiuj = [];   
        
        for (var vico of data)
        {
            var lingvo = new Lingvo (vico.id, vico.kodo, vico.nomo, vico.nacinomo, vico.fasado, vico.vortaro);
            this.ĉiuj.push (lingvo);
            this.lingvoj.set (parseInt(vico.id), lingvo);
            if (lingvo.fasado)
            {
                this.fasadLingvoj.push (lingvo);
            }
            
            if (lingvo.vortaro)
            {
                this.vortarLingvoj.push (lingvo);
            }
        }
        this.ŝarĝita = true;
        informilo ();
    }
    
    lingvo (id)
    {
        if (this.lingvoj.has(id))
        {
            return (this.lingvoj.get(id))
        } else
        {
            return (new Lingvo (id, '??', 'Lingvo ' + id, 'Lingvo ' + id, false, false));
        }        
    }
   
}

//export default Lingvoj;
    
var LINGVOJ = new Lingvoj();

export {LINGVOJ};    